/* Number ops */

import Settings from "./settings";
import Globals from "./globals";
import User from "./user";
import Storage from "./storage.service";
import Helpers from "./helpers";
import Flow from "./flow.service";
import Products from "./products.service";
import PlansService from "./plans.service";
import CONSTANTS from "./constants.service";
import HTTP from "./http.service";
import TimeService from "./time.service";
import Errors from "./errors.service";
import Events from "./events.service";
// import { userHasDevicePlan } from "./vip.bundle.service";

var Numbers = {};

Numbers.basic_vanities_ids = "1,2";
Numbers.vanity_ids = Object.keys(Settings.vanity_map).join(",");
Numbers.per_page = 10;

Numbers.initSelectNumber = (numberObj, skip_confirmation = false) => {
	Numbers.getNumber()
		.then((response) => {
			if (response.data && response.data.numbers.length > 0) {
				let number = response.data.numbers[0];
				Numbers.cancel(number["MSISDN"])
					.then((res) => {
						Numbers.setNumberToSelect(numberObj, skip_confirmation);
					})
					.catch((error) => {
						Globals.handleError(error, '29');
					});
			} else {
				Numbers.setNumberToSelect(numberObj, skip_confirmation);
			}
		})
		.catch((error) => {
			Globals.handleError(error, '30');
		});
};

Numbers.calculateExpiryTime = (numberObj) => {
	let format = "DD-MM-YYYY HH:mm:ss";
	let ReservationDate = TimeService.getTime(numberObj.ReservationDate, format);
	let ExpiryDate = TimeService.getTime(numberObj.ExpiryDate, format);
	let diff = TimeService.getTimeLeft(ReservationDate, ExpiryDate);
	return diff;
}

Numbers.getShuffleList = () => {
	Storage.set("shuffling", true);
	let vanities = Numbers.basic_vanities_ids; // + Numbers.vanity_ids; // all

	let shuffle_page = Storage.get("shuffle_page") || 1;

	Numbers.search("", 1, vanities)
		.then((response) => {
			if (response.data && response.data.numbers) {
				Storage.set("shuffle_page", shuffle_page + 1);
				Storage.set("search_shuffle_list", response.data.numbers);
			} else {
				Storage.set("shuffle_page", 1);
				Storage.set("search_shuffle_list", []);
			}
			Storage.set("shuffling", false);
		})
		.catch((error) => {
			Storage.set("shuffle_page", 1);
			Storage.set("search_shuffle_list", []);
			Storage.set("shuffling", false);
		});
};

Numbers.confirmCurrent = () => {
	Storage.set("number_confirmed_on_entry", true);
}

Numbers.shuffleRandomNumber = () => {
	Numbers.getShuffleList();

	Storage.set("shuffling", true);
	Products.clear();

	let number = Storage.get("number");

	if (number) {
		Numbers.cancel(number["MSISDN"])
			.then((res) => {
				Numbers.getRandomAndSave();
			})
			.catch((error) => {
				Storage.set("shuffling", false);
				Globals.handleError(error, '31');
			});
	} else {
		Numbers.getRandomAndSave();
	}
};

Numbers.setSearchFilter = (filter) => {
	
	let plans_filter = Storage.get("filter_vip_plans_page");

	if(plans_filter && plans_filter !== filter){
		Storage.set("show_vanity_warning", true);
		Storage.set("show_vanity_warning_filter", filter);
	} else {

		if (Storage.get("searching")) {
			return;
		}

		Storage.clear("filter_vip_plans_page");
		Storage.set("filter_vip", filter);
		Storage.set("search_page", 1);

		setTimeout(() => {
			Numbers.startSearch(false);
		}, 50);
	}

};

Numbers.clearSearchData = () => {
	Storage.clear("search_fragment");
	Storage.clear("searching");
	Storage.clear("search_appending");
	Storage.clear("search_results");
	Storage.clear("search_latest");
	Storage.clear("search_page");
	Storage.clear("searching");
	Storage.clear("search_no_match");
};

Numbers.startSearch = (append = true) => {
	let page = 1;
	if (append && Storage.get("search_page")) {
		page = Storage.get("search_page") + 1;
	} else {
		Storage.set("search_page", 1);
	}

	let vanities = Numbers.basic_vanities_ids + "," + Numbers.vanity_ids; // all

	let filter = Storage.get("filter_vip");

	if (filter) {
		if (!isNaN(filter)) {
			// is number
			// specific vip sent as id
			vanities = filter;
		} else {
			vanities = Numbers.vanity_ids; // vip only
			let vanity_id = Numbers.getVanityIdByName(filter);
			if (vanity_id) {
				// specific vip sent as name
				vanities = vanity_id;
			}
		}
	}

	let fragment = Storage.get("search_fragment") || "";

	Storage.set("latest_search_fragment", fragment);

	Storage.set("searching", true);
	Storage.set("search_appending", append);
	Storage.set("search_page", page);

	Numbers.search(fragment, page, vanities)
		.then((response) => {
			if (response.data) {
				// @Todo this.refs["fragment"].blur();

				let initial = Storage.get("search_results");

				let is_recommended_number = Storage.get("search_is_recommended_number"); 

				if (append) {
					if (page !== 1) {
						// Events.when_search_results_response(response.data.numbers);
					}
				} else {
					is_recommended_number = response.data.is_recommended_number;
					initial = [];
				}

				// Events.when_search_results_response(response.data.numbers);

				Storage.set("search_is_recommended_number", is_recommended_number);
				Storage.set("search_results", initial.concat(response.data.numbers));
				Storage.set("search_latest", response.data.numbers);
				Storage.set("searching", false);
			}
		})
		.catch((error) => {
			Storage.set("search_appending", false);
			Storage.set("searching", false);
			Storage.set("search_is_recommended_number", false);
			Storage.set("search_results", []);
			Storage.set("search_latest", []);
		});
};

Numbers.clearNumber = () => {
	Storage.clear("number");
	Storage.clear("msisdn");
	Storage.clear("msisdn_formatted");
	Storage.clear("vip_type");
	Storage.clear("number_confirmed_on_entry");
	Storage.clear("number_booked_using_search");
};

Numbers.setNumber = (obj, typePassed) => {
	
	let msisdn_formatted = Helpers.getNumberWithoutCountryCode(obj.MSISDN);
	msisdn_formatted = Helpers.formatPhoneNumber(msisdn_formatted);

	let in_transfer_number = obj.InTransferTo;
	
	if (in_transfer_number) {
		Storage.set("in_transfer_number", in_transfer_number);
		let in_transfer_to_formatted = Helpers.getNumberWithoutCountryCode(in_transfer_number);
		in_transfer_to_formatted = Helpers.formatPhoneNumber(in_transfer_to_formatted);
		Storage.set("in_transfer_to_formatted", in_transfer_to_formatted);
	} else {
		Storage.clear("in_transfer_number");
	}

	if(obj.MNPDetails){
		Storage.set("MNP_Details", obj.MNPDetails);
	}

	Storage.set("number", obj);
	Storage.set("msisdn", obj.MSISDN);
	Storage.set("msisdn_formatted", msisdn_formatted);

	// Events.when_number_is_selected(obj);
};

Numbers.getProductVanity = (product = null) => {
	let type = "";
	let vanity = 1;
	if(!product){
		let saved = Storage.get("saved_plan");
		if(saved){
			vanity = Helpers.getVanityLevel(saved);
		}
	}
	if(product){ 
		vanity = Helpers.getVanityLevel(product);
	}
	if (vanity > 1) {
		let vanityItem = Settings.vanity_map["" + vanity];
		type = "VIP-" + vanityItem["name"];
	}
	return type;
};

Numbers.reserveMNP = (number, operator) => {
	// if (User.isLoggedInProper()) {
	// 	Numbers.clearMNP();
	// }

	let config = {
		method: "post",
		url: "/mobile_number_portability/reserve_without_temp.json",
		data: {
			number: number,
			operator: operator,
		},
	};
	return HTTP(config);
};


Numbers.getNumberStatus = () => {
	if(Storage.get("fetching_number_status")){
		return
	}
	Storage.set("fetching_number_status", true);
	let fetcher = Numbers.getNumber();
	fetcher.then((numberResponse) => {
		if (numberResponse.data && numberResponse.data.numbers.length > 0) {
			let number = numberResponse.data.numbers[0];
			Numbers.setNumber(number);
		} else {
			Storage.set("number", false);
		}
		Numbers.getNumberScreen();
	})
	.catch((error) => {
		Globals.handleError(error, '32');
	}).finally(()=>{
		Storage.clear("fetching_number_status")
	})
	return fetcher;
};

Numbers.afterNumberTransfer = (response, MSISDN) => {
	Storage.set("msisdn", MSISDN);
	Storage.set("original_num", MSISDN, true);
	Numbers.clearMNP();
	// Products.saveCurrentProduct("afterNumberTransfer")
	// 	.then((resp) => {
			User.flowStatus(12)
				.then((status) => {
					Flow.next("number");
				})
				.catch((error) => {
					Numbers.handleError(error);
				});
		// })
		// .catch((error) => {
		// 	Numbers.handleError(error);
		// });
};

Numbers.confirmTransfer = (form) => {
	let MSISDN = form["current_number"]["value"];
	let operator = form["current_operator"]["value"];

	Numbers.getNumber()
		.then((numberResponse) => {
			if (numberResponse.data && numberResponse.data.numbers.length > 0) {
				let number = numberResponse.data.numbers[0];
				Numbers.cancel(number["MSISDN"])
					.then((res) => {
						Numbers.reserveMNP(MSISDN, operator)
							.then((response) => {
								Numbers.afterNumberTransfer(response, MSISDN);
							})
							.catch((error) => {
								Globals.handleError(error, '33');
							});
					})
					.catch((error) => {
						Globals.handleError(error, '34');
					});
			} else {
				Numbers.reserveMNP(MSISDN, operator)
					.then((response) => {
						Numbers.afterNumberTransfer(response, MSISDN);
					})
					.catch((error) => {
						Globals.handleError(error, '35');
					});
			}
		})
		.catch((error) => {
			Globals.handleError(error, '36');
		});
};

Numbers.clearMNP = () => {
	Storage.clear("mnp");
};

Numbers.initConfirmTransfer = () => {
	let form = Storage.get("mnp");
	Numbers.confirmTransfer(form);
};

Numbers.verify_mnp = (form) => {
	let config = {
		method: "post",
		url: "/mobile_number_portability/verify",
		data: {
			external_number: form["current_number"]["value"],
			operator: form["current_operator"]["value"],
		},
	};
	return HTTP(config);
};

Numbers.verifyPortability = (form) => {
	Numbers.verify_mnp(form)
		.then((response) => {
			Storage.set("mnp", form);
			Flow.goTo("/number/transfer-terms");
		})
		.catch((error) => {
			Globals.handleError(error);
		});
};

Numbers.getNumberScreen = () => {
	let screen = CONSTANTS.LOADING;
	let numberObj = Storage.get("number");

	if (numberObj) {
		if (Storage.get("navigating_within_app")) {
			if (Settings.enable_number_warning) {
				Storage.set("loading_text", "");
				screen = CONSTANTS.WARNING;
			} else {
				Numbers.cancelNumber();
				Storage.set("loading_text", "");
				screen = CONSTANTS.RANDOM;
			}
		} else {
			Storage.set("loading_text", "");
			screen = CONSTANTS.STORED;
		}
	} else {
		// check if user coming from switch-to-us langing page
		if (!sessionStorage.getItem('switch-to-us-popup-shown') && 
		document.referrer.includes('switch-to-us')
		){
			sessionStorage.setItem('switch-to-us-popup-shown',true);
			Storage.set("loading_text", "");
			screen = CONSTANTS.SWITCHTOUS;
		}else {
			Storage.set("loading_text", "");
			screen = CONSTANTS.RANDOM;
		}
	}
	Storage.set("number_screen", screen);
}

Numbers.cancelNumber = (callback = () => {}) => {

	Products.clear();

	let number = Storage.get("number");

	if (number) {
		Numbers.cancel(number["MSISDN"])
			.then((res) => {
				User.flowStatus(115).then(res=>{
					Numbers.clearNumber();
				}).catch(error=>{
					Numbers.clearNumber();
				}).finally(()=>{
					callback();
				})
			})
			.catch((error) => {
				Globals.handleError(error, '37');
				callback();
			})
	} else {
		Numbers.clearNumber();
		callback();
	}
};

Numbers.getRandomAndSaveWithDelete = () => {

	Products.clear();

	let number = Storage.get("number");

	if (number) {
		Numbers.cancel(number["MSISDN"])
			.then((res) => {
				Numbers.clearNumber();
				Numbers.getRandomAndSave();
			})
			.catch((error) => {
				Globals.handleError(error, '38');
			});
	} else {
		Numbers.clearNumber();
		Numbers.getRandomAndSave();
	}
};

Numbers.getRandomAndSave = () => {
	Numbers.clearNumber();
	Numbers.getRandomNumber()
		.then((res) => {
			// let number = 0 + res.data.MSISDN.substring(3);

			let product_save = Helpers.emptyPromise();

			// if (!Products.isCurrentProductUserSelected()) {
			// 	product_save = Products.saveCurrentProduct("getRandomAndSave");
			// }

			product_save
				.then((response) => {
					User.flowStatus(5)
						.then((response) => {
							Storage.set("shuffling", false);
							Numbers.setNumber(res.data, "Random");
						})
						.catch((error) => {
							Storage.set("shuffling", false);
							Globals.handleError(error, '39');
						});
				})
				.catch((error) => {
					Storage.set("shuffling", false);
					Globals.handleError(error, '40');
				});
		})
		.catch((error) => {
			Storage.set("shuffling", false);
			Globals.handleError(error, '41');
		});
};

Numbers.getRandomNumber = () => {
	let config = {
		method: "post",
		url: "/numbers/random",
	};
	return HTTP(config);
};

Numbers.getVanityIdByName = (name) => {
	if (name === "no_vip" || name === "no-vip"  || name === Numbers.basic_vanities_ids) {
		return Numbers.basic_vanities_ids;
	}

	if (name === "all" || name === "true" || name === Numbers.vanity_ids) {
		return Numbers.vanity_ids;
	}

	if (name && name !== true) {
		let arg_name_safe = name.toLowerCase().replace(" ", "_").replace("+", "");

		for (let key of Object.keys(Settings.vanity_map)) {
			let name_safe = Settings.vanity_map[key]["name"]
				.toLowerCase()
				.replace(" ", "_")
				.replace("+", "");

			if (name_safe === arg_name_safe) {
				return key;
			}
		}
	}

	return false;
};



Numbers.handleError = (error) => {
	let code =
		error.response && error.response.data && error.response.data.code
			? error.response.data.code
			: true;
	let type = Errors.getErrorType(code);
	Globals.setError(type);
};

Numbers.cancelNumberAndReload = (skipWarning = false) => {
	Numbers.clearMNP();
	Storage.set("number_screen", CONSTANTS.LOADING);
	let callback = () => {
		Numbers.getNumberScreen();
		Flow.goTo();
	}
	let number = Storage.get("number");
	if(skipWarning){
		Numbers.cancelNumber(Numbers.getNumberScreen);
	} else {
		if (number) {
			let vip_type = Helpers.isVipNumber(Helpers.getVanityLevel(number));
			if(vip_type && Storage.get("number_screen") !== CONSTANTS.WARNING){
				Storage.set("number_screen", CONSTANTS.WARNING);
				Flow.goToStepBase("number");
			} else {
				Numbers.cancelNumber(callback);
			}
		} else {
			Numbers.cancelNumber(callback);
		}
	}
}

Numbers.confirmNumberOnEntry = () => {
	Numbers.confirmCurrent();
 	Flow.next("number");
}

Numbers.goToSearchVip = (vanity) => {
	Storage.set("searching", true);
	Storage.set("filter_vip", vanity);
	Flow.goTo("/number/search");
}

Numbers.goToSearch = () => {
	Storage.set("searching", true);
	Flow.goTo("/number/search");
};

Numbers.goToMNP = () => {
	Flow.goTo("/number/transfer");
};

Numbers.search = (fragment, page, vanity_level_ids = "1,2,10,18,17") => {
	let data = {};
	data["per_page"] = Numbers.per_page; // * page;
	data["page"] = page;
	data["pattern"] = fragment;
	data["vanity_level_ids"] = vanity_level_ids;

	let config = {
		method: "post",
		url: "/numbers/search",
		data: data,
	};
	return HTTP(config);
};

Numbers.getNumber = () => {
	let config = {
		method: "get",
		url: "/numbers",
	};

	let returned = HTTP(config);

	returned
		.then((numberResponse) => {
			if (numberResponse.data && numberResponse.data.numbers.length > 0) {
				Numbers.setNumber(numberResponse.data.numbers[0]);
			} 
		})
		.catch((error) => {
			
		});

	return returned;
};

Numbers.getTerminatedNumber = () => {
	let config = {
		method: "get",
		url:
			"/customer/terminated_account_numbers?email=" +
			Storage.get("terminated_email"),
	};
	return HTTP(config);
};

Numbers.commitNumber = (data) => {
	let config = {
		method: "post",
		url: "/numbers/commit_number",
		data: data,
	};
	return HTTP(config);
};

Numbers.cancel = (MSISDN) => {
	let data = {};
	data["number"] = "0" + MSISDN.substr(3);

	let config = {
		method: "delete",
		url: "/numbers",
		data: data,
	};

	let f = HTTP(config);

	f.then(res=>{
		// Products.saveDefaultProduct();
		// let product = Products.getProductByCommitment(12);

		// Products.saveProduct(product);
	}).catch(err=>{

	});

	return f;
};

Numbers.back = () => {
	// Storage.set("searching", false);
	// Storage.set("vip_type", false);
	Flow.goHome();
};

Numbers.backToSearch = () => {
	// Storage.set("searching", true);
	// Storage.set("vip_type", false);
	Flow.goTo("/number/search");
};

Numbers.setNumberToSelect = (numberObj, skip_confirmation = false) => {
	Storage.set("number_to_select", numberObj);
	let vip_type = Helpers.isVipNumber(Helpers.getVanityLevel(numberObj));
	Storage.set("vip_type", vip_type);
	Storage.set("number_booked_using_search", true);
	// let safe_vip_type = vip_type
	// 	.toLowerCase()
	// 	.replace("+", "plus")
	// 	.replace(" ", "-");
		
	if (vip_type) {
		Storage.set("show_vip_confirmation", true);
		//Flow.goTo("/number/vip-" + safe_vip_type);
	} else {
		if (
			skip_confirmation ||
			(Settings.enable_number_confirm_ab && window.number_confirm_ab)
		) {
			Numbers.selectTheNumber();
			Events.when_an_ab_test_is_shown('number_confirm_ab');
		} else {
			Flow.goTo("/number/confirmation");
		}
	}
};

Numbers.selectTheNumber = () => {
	Storage.clear("search");
	Storage.clear("searching");
	Storage.clear("filter_vip");

	let number_to_select = Storage.get("number_to_select");
	let MSISDN = number_to_select?.MSISDN;
	Numbers.select(MSISDN)
		.then((response) => {

			// Storage.clear("number_to_select");

			Numbers.setNumber(response.data, "Custom");

			User.flowStatus(12)
			.then((status) => {
				if (Numbers.isBundleProductByID(number_to_select?.VanityLevel)){
					Flow.goTo('/choose-your-iphone');
				}else{
					PlansService.getSavedPlans().then(res => {
						PlansService.afterSelectingPlanAndNumber(res?.data)
				}).catch(error=>{
					Storage.clear("show_vip_confirmation");
					Flow.next();
				});
					}
			})
			.catch((error) => {
				Storage.clear("show_vip_confirmation");
				Numbers.handleError(error);
			});
			
		})
		.catch((error) => {
			Storage.clear("show_vip_confirmation");
			Numbers.handleError(error);
		});
};

Numbers.select = (MSISDN) => {
	let data = {};

	data["number"] = "971" + MSISDN.substr(1);

	let config = {
		method: "post",
		url: "/numbers",
		data: data,
	};
	return HTTP(config);
};
Numbers.fetchNumber = (reservation_ids = "1,3,4,5", callee = "default") => {
    let config = {
        method: "get",
        url: "/numbers?reservation_ids=" + reservation_ids + "&random=" + Date.parse(new Date())
    };
    return HTTP(config);
};

Numbers.isBundleProductByID = (id=null) => {
	id = parseInt(id);
	return Settings.bundle_products_vanity_levels.includes(id);
}

Numbers.isBundleProductByName = (vanity_text) => {
	if (vanity_text){
		vanity_text = vanity_text.toLowerCase();
		let vanArr = Settings.vanity_map;
		let vanity = Object.keys(vanArr).find(v=>vanity_text.toLowerCase().includes(vanArr[v].name.toLowerCase()));
		if(vanity) return Numbers.isBundleProductByID(vanity);
	}
	return false;
}


Numbers.vipBundleProductCommitment = (vanity_text) => {
	let isBundle = Numbers.isBundleProductByName(vanity_text);
	return isBundle? "VIP_BUNDLE_COMMITMENT":"VIP_NON_BUNDLE_COMMITMENT"
}

Numbers.isBundlePlan = (saved_plan) => {
	// read from saved plan if vip and bundle :
	let isBundle = false;
	if (!saved_plan) saved_plan = Storage.get("saved_plan");
	if (saved_plan){
		if (saved_plan.product.ProductCategory==="VIP"){
			isBundle = Numbers.isBundleProductByID(saved_plan.VanityLevel);
		}
	}else{ 
		// number selected but plan not saved yet
		// to save bundle plan, device must be selected first
		let number_to_select = Storage.get("number_to_select");
		if (number_to_select){
			isBundle = Numbers.isBundleProductByID(number_to_select.VanityLevel);
		}
	}
	return isBundle;
}

Numbers.getVanityNameByID = (id) => {
	if(id){
		if (id in Settings.vanity_map){
			let name = Settings.vanity_map[id]['name'];
			return name? name : '';
		}
	}
	return '';
}

Numbers.getVanityOrder = (vanity_id) => {
	// return vanity order on the list:
	let order = 0;
	if (!vanity_id) return order;
	let vm = Settings.vanity_map;
	let vanity = Object.values(vm).find(i=>i.key.toString()===vanity_id.toString())
	if (vanity) order = vanity['order'];
	return order;
}

const unreserveNumber = async () => {
	await Numbers.getNumber().then(({data})=>{
		if (data){
			let number = data.numbers?.[0]?.MSISDN;
			if (number){
				Numbers.cancel(number).then(()=>{
					Numbers.clearNumber();
				})
			}
		}
	})
}
export {
	unreserveNumber
}
export default Numbers;
